import request from '@/util/request';
// 获取列表
export const getContractSettlementList = (params, options) =>
    request.get('/api/v4ward/contract/paymentrecord/recordPage', Object.assign({}, options, { params }));

//新增

export const addContractSettlement = (params, options) =>
request.post('/api/v4ward/contract/paymentrecord/save', params, options)

//详情（回显）
export const getContracInvoiceRecordDetail = (id) =>
    request.get('/api/v4ward/contract/paymentrecord/detail?id='+id);

//删除
export const removeContracInvoiceRecordDetail = (id) =>
    request.post('/api/v4ward/contract/paymentrecord/remove?ids='+id);

//删除
export const editContracInvoiceRecordDetail = (params, options) =>
request.post('/api/v4ward/contract/paymentrecord/update', params, options)
